import React, { useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import cx from 'classnames';
import { isNil } from 'lodash';

import { ReactComponent as CelebrationIcon } from 'pages/Teachers/ClassroomInsights/assets/celebration-icon.svg';
import { ReactComponent as ReviseIcon } from 'pages/Teachers/ClassroomInsights/assets/revise-icon.svg';
import { ReactComponent as InfoIcon } from 'pages/Teachers/ClassroomInsights/assets/tomorrow-focus-icon.svg';
import PreviewField from 'pages/Teachers/shared/PreviewField';
import { colors } from 'theme/palette';

import Typography from 'components/Typography';

import styles from './style.module.scss';

const TomorrowsFocus = ({ celebrationsStudents, tomorrowsFocus }) => {
  const [loadAllStudents, setLoadAllStudents] = useState(false);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <InfoIcon />
        <Typography variant="S-TEAXT-2" color={colors.grey2}>
          Tomorrow's Focus
        </Typography>
      </header>
      <Divider className={styles.divider} />
      <div className={styles.revisitSection}>
        <header className={styles.sectionHeader}>
          <ReviseIcon />
          <Typography variant="S-TEAXT-2">Revisit</Typography>
        </header>

        <ul className={styles.content}>
          {!isNil(tomorrowsFocus) &&
            tomorrowsFocus.map((item, idx) => (
              <li key={idx}>
                <PreviewField initialValue={item} />
              </li>
            ))}
        </ul>
      </div>

      <div
        className={cx(styles.celebrationsSection, {
          [styles.noStudentsSection]: celebrationsStudents?.length === 0
        })}
      >
        <header className={cx(styles.sectionHeader, styles.withStudents)}>
          <div>
            <CelebrationIcon />
            <Typography variant="S-TEAXT-2">Celebrations</Typography>
          </div>
          {celebrationsStudents?.length > 0 && (
            <div className={styles.studentCount}>
              {celebrationsStudents?.length}{' '}
              {celebrationsStudents?.length === 1 ? 'Student' : 'Students'}
            </div>
          )}
        </header>
        <div className={styles.content}>
          {isNil(celebrationsStudents) && (
            <div className={styles.noStudents}>
              <CircularProgress size={30} />
            </div>
          )}
          {!isNil(celebrationsStudents) &&
            celebrationsStudents?.length === 0 && (
              <div className={styles.noStudents}>
                No students have mastered the concept yet.
              </div>
            )}

          {celebrationsStudents?.length > 0 && (
            <>
              <ul>
                <li>
                  {celebrationsStudents?.length}{' '}
                  {celebrationsStudents?.length === 1 ? 'student' : 'students'}{' '}
                  mastered the concept!
                </li>
              </ul>
              <div className={styles.students}>
                {celebrationsStudents?.length > 2 && !loadAllStudents && (
                  <>
                    {celebrationsStudents?.slice(0, 2).map((student, index) => (
                      <div key={index} className={styles.student}>
                        {student.student_name}
                      </div>
                    ))}
                    <div
                      className={styles.loadMore}
                      onClick={() => setLoadAllStudents(true)}
                    >
                      + {celebrationsStudents?.length - 2} more
                    </div>
                  </>
                )}
                {loadAllStudents && (
                  <>
                    {celebrationsStudents?.map((student, index) => (
                      <div key={index} className={styles.student}>
                        {student.student_name}
                      </div>
                    ))}
                    {celebrationsStudents?.length > 2 && (
                      <div
                        className={styles.loadMore}
                        onClick={() => setLoadAllStudents(false)}
                      >
                        show less
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TomorrowsFocus;
